import { getAppConfig } from "@/config/env"

/**
 * 跳转到外部重置密码页面（与登录页「重置密码」入口一致）。
 * 在新标签页打开，重置完成后由外部页面根据 redirectUrl 跳回登录页。
 */
export function goToResetPassword(): void {
  const { siteUrl, resetPassUrl } = getAppConfig()
  const redirectUrl =
    location.hostname === "web-game.ked.ksyun.com"
      ? "https://web-game.ked.ksyun.com/login"
      : `${siteUrl}/login`
  window.open(`${resetPassUrl}/?redirectUrl=${redirectUrl}`, "_blank")
}
